import HeaderContainer from "../../components/HeaderContainer";
import Header from "../../components/Header";
import Navbar from "../../components/Navbar";
import ContentWrapper from "../../components/ContentWrapper";
import SubNavbarPlano from "../../components/SubNavbarPlano";
import BoxPlanoInsDocs from "./_components/BoxPlanoInsDocs";

const PlanoInsDocs = () => {
  return (
    <>
      <HeaderContainer>
        <Header />
        <Navbar idx={1} />
      </HeaderContainer>

      <ContentWrapper>
        <SubNavbarPlano idx={3} />
        <BoxPlanoInsDocs />
      </ContentWrapper>
    </>
  );
};

export default PlanoInsDocs;
